import request from '@/utils/request'

/** 白名单列表 */
export function getWhitelist(keyword, communityId, page = 1, size = 10) {
  return request({
    url: '/manage/whitelist/list',
    method: 'get',
    params: { keyword, communityId, page, size }
  })
}

/** 批量导入 */
export function batchImportWhitelist(list) {
  return request({
    url: '/manage/whitelist/batch-import',
    method: 'post',
    data: list
  })
}

/** 删除 */
export function deleteWhitelist(id) {
  return request({
    url: `/manage/whitelist/${id}`,
    method: 'delete'
  })
}

/** 更新标签 */
export function updateWhitelistTags(id, tags) {
  return request({
    url: `/manage/whitelist/update-tags/${id}`,
    method: 'post',
    data: { tags }
  })
}
